import {IDropDownItemViewModel} from "./drop-down-item-view-model.interface";
import React from "react";

export abstract class DropDownItemModel implements IDropDownItemViewModel{
    abstract get id(): string;
    abstract applyFilter(filter: string): boolean;
    abstract renderItem(): React.ReactElement;
    abstract formatText(): string;
}
